<div class="mt-2 mb-3 d-flex" *ngIf="control">
  <p-checkbox [id]="componentId" [formControl]="control" [binary]="true" [label]="label | translate" (onChange)="onChangeEvent($event)" [disabled]="readonly"></p-checkbox>
  <ng-content select="[customLabel]"></ng-content>
  <ui-form-validation-messages *ngIf="showValidationMessages" [control]="control"></ui-form-validation-messages>
</div>
